import * as React from 'react';
import {FormattedMessage} from "react-intl";

import {ObjectStatus} from "features/search/filters/enums";

import './_residenceExplorerStatusDescriptionModal.scss';

import {P} from "@atoms/Text/P";
import { Tags, TagDesign } from '@atoms/Tags/Tags';
import {SiteSpecificContent} from "@atoms/SiteSpecificContent";
import {Headline} from '@atoms/Text/Headline';
import {HeadlineLevel} from 'features/ui/enums';

interface Props {
    hideForSale?: boolean;
    hideSoldObjects: boolean;
    hideReserved?: boolean;
    hideBooked?: boolean;
    premises?: boolean;
}

export const ResidenceExplorerStatusDescriptionModal: React.FunctionComponent<Props> = ({hideForSale, hideSoldObjects, hideReserved, hideBooked, premises}) => {
    return (
        <div className="residence-explorer__popup-content">
            <Headline level={HeadlineLevel.H3}><FormattedMessage id="jm.components.ResidenceExplorerStatusDescription.showResults" /></Headline>

            <ul>
                {(!hideForSale && !premises) &&
                    <li>
                        <Tags 
                            tagDesign={TagDesign.DOT} 
                            status={ObjectStatus.FOR_SALE} 
                            className='status' 
                        />
                        <P>
                            <strong>
                                <FormattedMessage id="jm.components.ResidenceTags.forsaleObject" />
                            </strong> - <FormattedMessage id="jm.components.ResidenceExplorerStatusDescription.forSaleDescription" />
                        </P>
                    </li>
                }
                {(!hideForSale && premises) &&
                    <li>
                        <Tags 
                            tagDesign={TagDesign.DOT} 
                            status={ObjectStatus.FOR_SALE} 
                            className='status' 
                        />
                        <P>
                            <strong>Ledig</strong> - Lokalen är tillgänglig och ute till försäljning.
                        </P>
                    </li>
                }
                {hideForSale &&
                    <SiteSpecificContent showOnFinland>
                        <li>
                            <Tags 
                                tagDesign={TagDesign.DOT} 
                                status={ObjectStatus.PRESELLING} 
                                className='status' 
                            />
                            <P>
                                <strong>
                                    <FormattedMessage id="jm.components.ResidenceTags.preSelling" />
                                </strong> - <FormattedMessage id="jm.components.ResidenceExplorerStatusDescription.preSaleDescription" />
                            </P>
                        </li>
                    </SiteSpecificContent>
                }
                {!hideReserved &&
                    <SiteSpecificContent>
                        <li>
                            <Tags 
                                tagDesign={TagDesign.DOT} 
                                status={ObjectStatus.RESERVED} 
                                className='status' 
                            />
                            <P>
                                <strong>
                                    <FormattedMessage id="jm.components.ResidenceExplorerStatusDescription.reserved"/>
                                </strong> - <FormattedMessage id="jm.components.ResidenceExplorerStatusDescription.reservedDescription"/>
                            </P>
                        </li>
                    </SiteSpecificContent>
                }
                {!hideBooked &&
                    <SiteSpecificContent notNorway>
                        <li>
                            <Tags 
                                tagDesign={TagDesign.DOT} 
                                status={ObjectStatus.BOOKED} 
                                className='status' 
                            />
                            <P>
                                <strong>
                                    <FormattedMessage id="jm.components.ResidenceExplorerStatusDescription.booked" />
                                </strong> - <FormattedMessage id="jm.components.ResidenceExplorerStatusDescription.bookedDescription" />
                            </P>
                        </li>
                    </SiteSpecificContent>
                }
                {!hideSoldObjects &&
                    <li>
                        <Tags 
                            tagDesign={TagDesign.DOT} 
                            status={ObjectStatus.SOLD} 
                            className='status' 
                        />
                        <P>
                            <strong>
                                <FormattedMessage id="jm.components.ResidenceExplorerStatusDescription.sold" />
                            </strong> - <FormattedMessage id="jm.components.ResidenceExplorerStatusDescription.soldDescription" />
                        </P>
                    </li>
                }
                {premises &&
                    <li>
                        <Tags 
                            tagDesign={TagDesign.DOT} 
                            status={ObjectStatus.SOLD} 
                            className='status' 
                        />
                        <P>
                            <strong>Uthyrd</strong> - Den här lokalen är uthyrd.
                        </P>
                    </li>
                }
            </ul>
        </div>
    )
};
